/*Global Dependencies*/
import React , {useEffect} from "react";
import {Tabs} from "antd";
import {map , cloneDeep} from 'lodash';
import { useLocation } from "react-router-dom";

/*Local Dependencies*/
import GenericExpense from "./genericExpense/genExpense";
import { useHighCostPatientStore } from "@stores/highCostPatientStore";
import {tabsList} from "../highCostPatientConstant";
import { ASC, DESC } from "@utils/constants";
import "./tableTabs.scss";

const { TabPane } = Tabs;

const TableTabs = ({refreshDate , top10 , buildDone , tableData , setTableData , totalCount , setTotalCount , tableLoader, setTableLoader , getTableData , columnData} : any) => {

    const rowsPerPage = useHighCostPatientStore((state) => state.rowsPerPage);
    const setRowsPerPage = useHighCostPatientStore((state) => state.setRowsPerPage);
    const currentPage = useHighCostPatientStore((state) => state.currentPage);
    const setCurrentPage = useHighCostPatientStore((state) => state.setCurrentPage);
    const sortData = useHighCostPatientStore((state) => state.sortData);
    const setSortData = useHighCostPatientStore((state) => state.setSortData);
    const searchData = useHighCostPatientStore((state) => state.searchData);
    const setSearchData = useHighCostPatientStore((state) => state.setSearchData);
    const searchKeywordNew= useHighCostPatientStore((state) => state.searchKeywordNew);
    const setSearchKeywordNew = useHighCostPatientStore((state) => state.setSearchKeywordNew);
    const setColumnData = useHighCostPatientStore((state) => state.setColumnData);
    const activeTab= useHighCostPatientStore((state) => state.activeTab);
    const setActiveTab = useHighCostPatientStore((state) => state.setActiveTab);
    const showModel= useHighCostPatientStore((state) => state.showModel);
    const setShowModel = useHighCostPatientStore((state) => state.setShowModel);
    const selectedRecord= useHighCostPatientStore((state) => state.selectedRecord);
    const location : any = useLocation();

    useEffect(() => {
      console.log("genExpense.useEffect1");
      if(buildDone){
        //to get the table data when we come back from encounters data and retain the sortOrder of the table
        handlePreviousSort({})
        getTableData({topVal : top10, limit :  rowsPerPage, page : currentPage[activeTab.expenseType] , expense : activeTab.expenseType , sortBy : sortData[activeTab.expenseType].sortBy , sortType : sortData[activeTab.expenseType].sortType});
      }   
    // eslint-disable-next-line react-hooks/exhaustive-deps
    } , [])

    const handlePreviousSort = ({expenseType = activeTab.expenseType , action = ''}) => {
      //to retain the sortOrder in the table when we come back from encounters data
      if((location?.state?.colSortConfig || action === 'tabChange') && sortData[expenseType]?.sortBy){
        const colData = cloneDeep(columnData[expenseType]);
        const index = colData.findIndex((a : any) => a.dataIndex === sortData[expenseType]?.sortBy);
        colData[index].sortOrder = sortData[expenseType]?.sortType === ASC ? "ascend" : (sortData[expenseType]?.sortType === DESC ? "descend" : undefined);
        setColumnData({...columnData , [expenseType] : colData});
      }
    }

    const onChangeTab = (key : string) => {
      //to set the current tab when we navigate from one tab to other
      console.log("TableTabs.onChangeTab");
      const currentTab = tabsList.find((tab) => tab.key === key) || tabsList[0];
      setActiveTab(currentTab);
      //action is added in handlePreviousSort to keep same sort change in all expense types
      handlePreviousSort({expenseType : currentTab.expenseType , action : 'tabChange'})
      if(buildDone){
        getTableData({page : currentPage[currentTab.expenseType] ,expense : currentTab.expenseType ,  sortBy : sortData[currentTab.expenseType].sortBy || 'none', sortType : sortData[currentTab.expenseType].sortType || 'none', searchOn : searchKeywordNew[currentTab.expenseType]});
      }
      
    }

    const handleTableData = (data : any , tab :  string) => {
      // to handle table data of each tab
      const currenttab = tab ? tab : activeTab.expenseType;
      setTableData({...tableData , [currenttab] : data});
    }

    return   <div className="high-cost__tab-container">
    <Tabs className="ui-care-coordination__program-tabs tab-menu" activeKey={activeTab.key} onChange={onChangeTab}  type="card">
      {map(tabsList , (item) => (
        <TabPane tab={<div className="ui-program-name">{item.tabName}</div>} key={item.key} className="ui-program"> 
          <GenericExpense activeTab={activeTab} refreshDate={refreshDate} showModel={showModel} setShowModel= {setShowModel} top10={top10} rowsPerPage={rowsPerPage} searchData={searchData} 
          setSearchData={setSearchData} searchKeywordNew={searchKeywordNew} setSearchKeywordNew ={setSearchKeywordNew} totalCount={totalCount} setTotalCount={setTotalCount}
          setRowsPerPage={setRowsPerPage} currentPage={currentPage} setCurrentPage ={setCurrentPage} sortData ={sortData} setSortData={setSortData} tableLoader={tableLoader} setTableLoader={setTableLoader}
          selectedRecord={selectedRecord} columnData={columnData} tableData={tableData} setTableData={handleTableData} buildDone={buildDone} getTableData={getTableData}
          />
          <div className={`default_message ${buildDone ? 'dnone' : ''}`}>Select the options to catch the high cost patients.</div>
      </TabPane>
      ))}
    </Tabs>
  </div>
}

export default TableTabs;